import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { getTokenCookie } from "../../views/Login/cookie";

const ProfileProveedor = () => {
  const [User, setUser] = useState({
    nameAndLastName: "" || "",
    dni: "" || "",
    cuit: "" || "",
    phone: "" || "",
    email: "" || "",
    placeOfResidence: "" || "",
    postalCode: "" || "",
    street: "" || "",
    numberStreet: "" || "",
    province: "" || "",
    cbu: "" || "",
  });
  const [load, setLoad] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [originalUser, setOriginalUser] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [changeForm, setChangeForm] = useState();

  useEffect(() => {
    async function fetchData() {
      const token = getTokenCookie();
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_GET_PROVEEDOR}${token}`
        );
        const userData = response.data;
        setUser(userData);
        setLoad(false);
        setOriginalUser(User);
        if (/^(30|33|34)/.test(userData.cuit)) {
          setChangeForm(true);
        }
      } catch (error) {
        setLoad(false);
      }
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNumericInputChange = (fieldName, value) => {
    // Filtrar caracteres no numéricos solo para CUIT, número y código postal
    let numericValue = value;
    if (
      ["cuit", "phone", "postalCode", "numberStreet", "dni"].includes(fieldName)
    ) {
      numericValue = value.replace(/[^0-9]/g, "");
    }
    setUser({ ...User, [fieldName]: numericValue });
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const updateUserInfo = async () => {
    if (!User.cbu || User.cbu.length !== 22) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El CBU debe tener exactamente 22 dígitos.",
      });
      return false;
    }

    try {
      setIsEditing(false);
      const res = await axios.post(
        `${process.env.REACT_APP_UPDATE_PROVEEDOR}`,
        {
          User,
        }
      );
      Swal.fire({
        icon: "success",
        title: "Éxito!",
        text: "Se han actualizado los datos correctamente." || res.data.message,
      });

      setIsEditing(false);
      // Obtener los nuevos datos del usuario y actualizar el estado
      const token = getTokenCookie();
      const response = await axios.get(
        `${process.env.REACT_APP_UPDATE_PROVEEDOR}${token}`
      );
      const userData = response.data;
      setUser(userData);
      setOriginalUser(userData);
    } catch (error) {}
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  return (
    <>
      {!load ? (
        changeForm ? (
          <div className="alternateForm">
            {/* Contenido del formulario alternativo */}
            <div className="allprovprofile">
              <div className="allformprovfile">
                <div className="dosplayinputProvprofile">
                  <div className="boxinputprovprofile">
                    <label className="labelformprovprofile">Razón social</label>
                    <input
                      className="inputupdateProvprofile"
                      type="text"
                      readOnly={!isEditing}
                      value={User.nameAndLastName || ""}
                      onChange={(e) =>
                        setUser({ ...User, nameAndLastName: e.target.value })
                      }
                    />
                  </div>
                  <div className="boxinputprovprofile">
                    <label className="labelformprovprofile">Cuit</label>
                    <input
                      className="inputupdateProvprofile"
                      type="text"
                      maxLength={11}
                      readOnly={!isEditing}
                      value={User.cuit || ""}
                      onChange={(e) =>
                        handleNumericInputChange("cuit", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="dosplayinputProvprofile">
                  <div className="boxinputprovprofile">
                    <label className="labelformprovprofile">Cbu</label>
                    <input
                      className="inputupdateProvprofile"
                      maxLength={22}
                      type="text"
                      readOnly={!isEditing}
                      value={User.cbu || ""}
                      onChange={(e) =>
                        setUser({ ...User, cbu: e.target.value })
                      }
                    />
                  </div>
                  <div className="boxinputprovprofile">
                    <label className="labelformprovprofile">Telefono</label>
                    <input
                      className="inputupdateProvprofile"
                      type="text"
                      readOnly={!isEditing}
                      value={User.phone || ""}
                      onChange={(e) =>
                        handleNumericInputChange("phone", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="dosplayinputProvprofile">
                  <div className="boxinputprovprofile">
                    <label className="labelformprovprofile">Email</label>
                    <input
                      className="inputupdateProvprofile"
                      type="email"
                      readOnly={!isEditing}
                      value={User.email || ""}
                      onChange={(e) =>
                        setUser({ ...User, email: e.target.value })
                      }
                    />
                  </div>
                  <div className="boxinputprovprofile">
                    <label className="labelformprovprofile">
                      Lugar de residencia
                    </label>
                    <input
                      className="inputupdateProvprofile"
                      type="text"
                      readOnly={!isEditing}
                      value={User.placeOfResidence || ""}
                      onChange={(e) =>
                        setUser({ ...User, placeOfResidence: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="dosplayinputProvprofile">
                  <div className="boxinputprovprofile">
                    <label className="labelformprovprofile">Calle</label>
                    <input
                      className="inputupdateProvprofile"
                      type="text"
                      readOnly={!isEditing}
                      value={User.street || ""}
                      onChange={(e) =>
                        setUser({ ...User, street: e.target.value })
                      }
                    />
                  </div>
                  <div className="boxinputprovprofile">
                    <label className="labelformprovprofile">Numero</label>
                    <input
                      className="inputupdateProvprofile"
                      type="text"
                      readOnly={!isEditing}
                      value={User.numberStreet || ""}
                      onChange={(e) =>
                        handleNumericInputChange("numberStreet", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="dosplayinputProvprofile">
                  <div className="boxinputprovprofile">
                    <label className="labelformprovprofile">Provincia</label>
                    <input
                      className="inputupdateProvprofile"
                      type="text"
                      readOnly={!isEditing}
                      value={User.province || ""}
                      onChange={(e) =>
                        setUser({ ...User, province: e.target.value })
                      }
                    />
                  </div>
                  <div className="boxinputprovprofile">
                    <label className="labelformprovprofile">
                      Codigo Postal
                    </label>
                    <input
                      className="inputupdateProvprofile"
                      type="text"
                      readOnly={!isEditing}
                      value={User.postalCode || ""}
                      onChange={(e) =>
                        handleNumericInputChange("postalCode", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="boxprovbuttonprfile">
                  {!isEditing ? ( // Si no está editando, mostrar el botón "Editar"
                    <button
                      className="buttonprovprofile"
                      onClick={handleEditClick}
                    >
                      Editar
                    </button>
                  ) : (
                    // Si está editando, mostrar botones "Actualizar" y "Cancelar"
                    <>
                      <button
                        className="buttonprovprofile"
                        onClick={updateUserInfo}
                      >
                        Actualizar
                      </button>
                      <button
                        className="buttonprovprofile"
                        onClick={handleCancelEdit}
                      >
                        Cancelar
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="allprovprofile">
            <div className="allformprovfile">
              <div className="dosplayinputProvprofile">
                <div className="boxinputprovprofile">
                  <label className="labelformprovprofile">
                    Nombre completo
                  </label>
                  <input
                    className="inputupdateProvprofile"
                    type="text"
                    readOnly={!isEditing}
                    value={User.nameAndLastName || ""}
                    onChange={(e) =>
                      setUser({ ...User, nameAndLastName: e.target.value })
                    }
                  />
                </div>
                <div className="boxinputprovprofile">
                  <label className="labelformprovprofile">Cuit</label>
                  <input
                    className="inputupdateProvprofile"
                    type="text"
                    maxLength={11}
                    readOnly={!isEditing}
                    value={User.cuit || ""}
                    onChange={(e) =>
                      handleNumericInputChange("cuit", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="dosplayinputProvprofile">
                <div className="boxinputprovprofile">
                  <label className="labelformprovprofile">Dni</label>
                  <input
                    className="inputupdateProvprofile"
                    type="text"
                    maxLength={8}
                    readOnly={!isEditing}
                    value={User.dni || ""}
                    onChange={(e) =>
                      handleNumericInputChange("dni", e.target.value)
                    }
                  />
                </div>
                <div className="boxinputprovprofile">
                  <label className="labelformprovprofile">Telefono</label>
                  <input
                    className="inputupdateProvprofile"
                    type="text"
                    readOnly={!isEditing}
                    value={User.phone || ""}
                    onChange={(e) =>
                      handleNumericInputChange("phone", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="dosplayinputProvprofile">
                <div className="boxinputprovprofile">
                  <label className="labelformprovprofile">Email</label>
                  <input
                    className="inputupdateProvprofile"
                    type="email"
                    readOnly={!isEditing}
                    value={User.email || ""}
                    onChange={(e) =>
                      setUser({ ...User, email: e.target.value })
                    }
                  />
                </div>
                <div className="boxinputprovprofile">
                  <label className="labelformprovprofile">
                    Lugar de residencia
                  </label>
                  <input
                    className="inputupdateProvprofile"
                    type="text"
                    readOnly={!isEditing}
                    value={User.placeOfResidence || ""}
                    onChange={(e) =>
                      setUser({ ...User, placeOfResidence: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="dosplayinputProvprofile">
                <div className="boxinputprovprofile">
                  <label className="labelformprovprofile">Calle</label>
                  <input
                    className="inputupdateProvprofile"
                    type="text"
                    readOnly={!isEditing}
                    value={User.street || ""}
                    onChange={(e) =>
                      setUser({ ...User, street: e.target.value })
                    }
                  />
                </div>
                <div className="boxinputprovprofile">
                  <label className="labelformprovprofile">Numero</label>
                  <input
                    className="inputupdateProvprofile"
                    type="text"
                    readOnly={!isEditing}
                    value={User.numberStreet || ""}
                    onChange={(e) =>
                      handleNumericInputChange("numberStreet", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="dosplayinputProvprofile">
                <div className="boxinputprovprofile">
                  <label className="labelformprovprofile">Provincia</label>
                  <input
                    className="inputupdateProvprofile"
                    type="text"
                    readOnly={!isEditing}
                    value={User.province || ""}
                    onChange={(e) =>
                      setUser({ ...User, province: e.target.value })
                    }
                  />
                </div>
                <div className="boxinputprovprofile">
                  <label className="labelformprovprofile">Codigo Postal</label>
                  <input
                    className="inputupdateProvprofile"
                    type="text"
                    readOnly={!isEditing}
                    value={User.postalCode || ""}
                    onChange={(e) =>
                      handleNumericInputChange("postalCode", e.target.value)
                    }
                  />
                </div>
              </div>

              <div
                style={{
                  margin: "10px 20px",
                  textAlign: "justify",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label className="labelformprovprofile">Cbu</label>
                <input
                  className="inputupdateProvprofile"
                  maxLength={22}
                  type="text"
                  readOnly={!isEditing}
                  value={User.cbu || ""}
                  onChange={(e) => setUser({ ...User, cbu: e.target.value })}
                />
              </div>

              <div className="boxprovbuttonprfile">
                {!isEditing ? ( // Si no está editando, mostrar el botón "Editar"
                  <button
                    className="buttonprovprofile"
                    onClick={handleEditClick}
                  >
                    Editar
                  </button>
                ) : (
                  // Si está editando, mostrar botones "Actualizar" y "Cancelar"
                  <>
                    <button
                      className="buttonprovprofile"
                      onClick={updateUserInfo}
                    >
                      Actualizar
                    </button>
                    <button
                      className="buttonprovprofile"
                      onClick={handleCancelEdit}
                    >
                      Cancelar
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )
      ) : (
        <div className="loader"></div>
      )}
    </>
  );
};

export default ProfileProveedor;
